<mwc-sidebar [structure]="sidebarStructure"
  (routingRequest)="changeRoute($event)">
</mwc-sidebar>
